export const defaultData = {
	year: {
		value: '2021',
	},
	documentDescription: {
		value: 'Lorem Ipsum',
		changeIndividual: true,
	},
	repetitionMeter: {
		value: 'Lorem Ipsum',
	},
	ils3: {
		value: 'Lorem Ipsum',
		changeIndividual: true,
	},
	monitoring: {},
	objectType: {
		value: 'Lorem Ipsum',
	},
	contract: {
		value: 'Lorem Ipsum',
		changeIndividual: true,
	},
	carUse: {
		value: 'Lorem Ipsum',
	},
	executionDate: {},
	source: {},
	engineeringOffice: {
		value: 'Lorem Ipsum',
	},
	ils2: {
		value: '123456789',
	},
};
